<template>
  <div class="mt-28px">
    <div class="flex items-center gap-2 mb-4">
      <h5><i class="dot"></i> 이동식크레인</h5>
      <p v-if="isPrint" class="print-input" style="width: 200px">{{ form.중량 }}</p>
      <vs-input v-else v-model="form.중량" :readonly="readonly" placeholder="중량"/>
      <span class="ml-2">톤</span>
    </div>

    <!-- 점검표 -->
    <table-inspect-merge
      class="mb-4"
      tableHeaderTitle="점검사항"
      :is-readonly="readonly"
      :table-header-check="[]"
      :tableHeaderCheck='[
        { text: "양호", width: "82" },
        { text: "불량", width: "82" },
      ]'
      :tableHeaderNote="[]"
      content-before="numbering"
      v-model="form.inspectList"
    >
      <template #trFooter>
        <div class="grid">
          <span class="border-bottom" style="padding: 14px">- 점검 Point</span>
          <div class="w-full flex ">
            <p class="flex-1 p-3 border-right flex items-center"><img :src="require('@/assets/images/장비/2-1.png')" class="w-full"></p>
            <p class="flex-1 p-3 border-right flex items-center"><img :src="require('@/assets/images/장비/2-2.png')" class="w-full"></p>
            <p class="flex-1 p-3 border-right flex items-center"><img :src="require('@/assets/images/장비/2-3.png')" class="w-full"></p>
            <p class="flex-1 p-3 border-right flex items-center"><img :src="require('@/assets/images/장비/2-4.png')" class="w-full"></p>
            <p class="flex-1 p-3 border-right flex items-center"><img :src="require('@/assets/images/장비/2-5.png')" class="w-full"></p>
            <p class="flex-1 p-3 flex items-center"><img :src="require('@/assets/images/장비/2-6.png')" class="w-full"></p>
          </div>
        </div>
      </template>
    </table-inspect-merge>

    <!-- 점검자  -->
    <div class="writeGridContainer">
      <div>
        <span>점검자(운전자)</span>
        <div>
          <p v-if="isPrint" class="print-input">{{ form.점검자 && form.점검자.name }}</p>
          <member-selector v-else v-model="form.점검자Id" popup-type="user" :memberName="form.점검자 && form.점검자.name" @select="(member) => form.점검자 = member" :readonly="statusNumber===0"/>
        </div>
      </div>
      <div>
        <span>소속</span>
        <div>
          <p v-if="isPrint" class="print-input">{{ form.점검자 && form.점검자.department }}</p>
          <ml-input v-else :value="form.점검자 && form.점검자.department" readonly/>
        </div>
      </div>
      <div>
        <span>서명</span>
        <div>
          <sign-field v-model="form.점검자서명" :readonly="statusNumber===0"/>
        </div>
      </div>
    </div>

    <!-- 점검상태 -->
    <div class="writeGridContainer">
      <div>
        <span>점검상태</span>
        <div>
          <radio-group v-model="form.점검상태" flex :items="['양호', '불량']" :readonly="statusNumber===0"/>
        </div>
      </div>
    </div>

    <!-- 확인자  -->
    <div class="writeGridContainer">
      <div>
        <span>확인자(사용주체)</span>
        <div>
          <p v-if="isPrint" class="print-input">{{ form.확인자 && form.확인자.name }}</p>
          <member-selector v-else v-model="form.확인자Id" popup-type="user" :memberName="form.확인자 && form.확인자.name" @select="(member) => form.확인자 = member" :readonly="statusNumber===0"/>
        </div>
      </div>
      <div>
        <span>소속</span>
        <div>
          <p v-if="isPrint" class="print-input">{{ form.확인자 && form.확인자.department }}</p>
          <ml-input v-else :value="form.확인자 && form.확인자.department" readonly/>
        </div>
      </div>
      <div>
        <span>서명</span>
        <div>
          <sign-field v-model="form.확인자서명" :readonly="statusNumber===0"/>
        </div>
      </div>
    </div>

    <!-- 확인상태 -->
    <div class="writeGridContainer">
      <div>
        <span>확인상태</span>
        <div>
          <radio-group v-model="form.확인상태" flex :items="['양호', '불량']" :readonly="statusNumber===0"/>
        </div>
      </div>
    </div>

    <!-- - 이동식크레인 구조 -->
    <div class="grid grid-cols-2">
      <div class="col-span-1">
        <h5 class="mb-4" style="font-weight:500; font-size: 16px; color:#2C2C2C">- 이동식크레인 구조</h5>
        <div>
          <img :src="require('@/assets/images/장비/2.png')" class="mx-auto" style="width: 100%; max-height:310px; object-fit: contain;"/>
        </div>
      </div>
      <div class="col-span-1">
        <h5 class="mb-4" style="font-weight:500; font-size: 16px; color:#2C2C2C">- 장비점검 유효기간</h5>
        <table class="w-full" >
          <colgroup>
            <col width="80"/>
            <col width="176"/>
          </colgroup>

          <tr>
            <th>차량소속</th>
            <td>
              <p v-if="isPrint" class="print-input">{{ form.차량소속 }}</p>
              <ml-input v-else class="w-full" v-model="form.차량소속" :readonly="readonly"/>
            </td>
          </tr>
          <tr>
            <th>차량번호</th>
            <td>
              <p v-if="isPrint" class="print-input">{{ form.차량번호 }}</p>
              <ml-input v-else class="w-full" v-model="form.차량번호" :readonly="readonly"/>
            </td>
          </tr>
          <tr>
            <th>정격하중</th>
            <td>
              <p v-if="isPrint" class="print-input">{{ form.정격하중 }}</p>
              <ml-input v-else class="w-full" v-model="form.정격하중" :readonly="readonly"/>
            </td>
          </tr>
          <tr>
            <th>제조년도</th>
            <td>
              <p v-if="isPrint" class="print-input">{{ form.제조년도 }}</p>
              <ml-input v-else class="w-full" v-model="form.제조년도" :readonly="readonly"/>
            </td>
          </tr>
          <tr>
            <th>인증여부<br><span style="font-weight: 400">(2009.10 이후 출고 차량)</span></th>
            <td>
              <p v-if="isPrint" class="print-input">{{ form.인증여부 }}</p>
              <ml-input v-else class="w-full" v-model="form.인증여부" :readonly="readonly"/>
            </td>
          </tr>
          <tr>
            <th>비고</th>
            <td>
              <p v-if="isPrint" class="print-input">{{ form.비고 }}</p>
              <ml-input v-else class="w-full" v-model="form.비고" :readonly="readonly"/>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import MemberSelector from "@/components/selector/MemberSelector.vue";
import SignField from "@/components/SignField.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import TableInspectMerge from "@/components/TableInspectMerge.vue";

export default {
  components: {TableInspectMerge, RadioGroup, SignField, MemberSelector},
  props: {
    readonly: Boolean,
    value: Object,
    isPrint: Boolean,
    statusNumber: Number,
  },
  computed: {
    form: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
}
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border-top: 1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;


  tr {
    background: #fff !important;
    border-bottom: solid 1px #cdcdcd;

    th {
      text-align: center;
      font-weight: 500;
      border-right: solid 1px #cdcdcd;
      background-color: #F9F9F9;
    }
    td {
      padding: 6px;
      border-right: solid 1px #cdcdcd;
    }
  }
}
</style>
